export * from "@awayjs/stage";



//////////////////
// WEBPACK FOOTER
// ./node_modules/awayjs-full/dist/lib/stage.js
// module id = 12
// module chunks = 22